import React from 'react'
import { Card } from '@myxplor/ui'
import NavigateByWeek from '../ui/navigate-by-week'
import { afterCCSStarted } from '../reports/helpers'
import { RegHolderName } from '../layout'

import { WeekIsBeforeCSS } from './views/before-ccs'
import ISSCaseClaimsList from './component'
import ExpiryMessage from '../ui/expiry-message'

// start_date is already a moment.js object and has been cast to the start of the week when the route is defined
const ISCaseClaimsWrapper = ({ base_url, start_date, record_type, id, embedded }) => {
  const isValidWeek = afterCCSStarted({ week_start_date: start_date })

  return (
    <Card title={<RegHolderName />} embedded={embedded}>
      <ExpiryMessage service_id={id}/>
      <NavigateByWeek base_url={base_url} start_date={start_date} view_type="ISS Case Claims" />

      {isValidWeek ? (
        <ISSCaseClaimsList
          start_date={start_date}
          record_type={record_type}
          record_id={id}
          base_url={base_url}
        />
      ) : (
        <WeekIsBeforeCSS />
      )}
    </Card>
  )
}

export default ISCaseClaimsWrapper



// WEBPACK FOOTER //
// ./src/iss-case-claims/index.js